<!-- 未使用 -->
<template>
  <div class="sonota">
    <h3>その他手当</h3>

    <div class="multi-date-table" v-for="(item, index) in sonota" :key="index">
      <div class="head"><b>その他手当{{ (index + 1) }}</b></div>
      <div class="flex">
        <div class="item ">
          <b class="required">手当</b>
          <select-box :options="options?.teate" v-model="item.mst_teate_id"
                  :error="getError(item, 'mst_teate_id')" :hasBlank="true"></select-box>
        </div>
        <div class="item ">
          <b class="required">取得日</b>
          <date-picker v-model="item.shinsei_date" :error="getError(item, 'shinsei_date')" ></date-picker>
        </div>
      </div>
      <div class="row-button">
        <i class="fa-solid fa-delete-left" @click="removeTableRow(sonota, index)" v-if="(sonota.length > 1)"></i>
      </div>
    </div>
    <p class="item btn-table-add">
      <button type="button" class="btn primary" @click="addRow">
        <i class="fa-solid fa-plus"></i>追加
      </button>
    </p>
    <div class="item">
      <b>備考</b>
      <input-textarea v-model="form.notes" :error="getError(form, 'notes')"></input-textarea>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import { useInit } from "@/composable/shinsei/sonota/init";
import { useForm } from "@/composable/form/form";
import { useTableRow } from "@/composable/common/tablerow";
import { Shinsei, Sonota } from '@/types/Shinsei';
import { ShinseiOption } from '@/types/Option';

export default defineComponent({
  props:{
    form: {
      type: Object as () => Shinsei,
      default: null
    },
    options:{
      type: Object as () => ShinseiOption,
      default: null
    }
  },
  setup(props) {
    const { sonota } = useInit(props.form);

    const { getError } = useForm();

    const { addRowNoRef, removeTableRow } = useTableRow();

    // 行追加
    const addRow = () => {
      const row: Sonota = {
        shinsei_date: null,
        mst_teate_id: null,
        teate_name: null
      }
      addRowNoRef(sonota, row)
    }

    return {
      sonota,
      getError,
      addRow,
      removeTableRow,
    }
  },
  components: {

  }
})

</script>
<style lang="scss" scoped>
@import '@scss/components/shinsei-create.scss';
</style>